import React, { Component, PropTypes } from 'react';
import { fadein } from '../decorators';
import DeckItem from './deckitem';
import Filter from './filter';
import AddButton from './addbutton';
import classnames from 'classnames';
import './decklist.css';

class DeckList extends Component {
    constructor(...args) {
        super(...args);

        this.state = {
            filter: ''
        };
    }
    changeFilter(filter) {
        this.setState({ filter });
    }
    render() {
        let { decks, onAdd, visible } = this.props;

        let classes = classnames({
            'deck-list': true,
            visible
        });
        let items = decks.map((deck) => <DeckItem key={deck.id} {...this.props} {...this.state} {...deck} />);

        return (<div className={classes}>
            <Filter onChange={ newVal => this.changeFilter(newVal) } {...this.state} />
            <div className="items">
                { items }
            </div>
            <AddButton onClick={ onAdd } />
        </div>);

    }
}

DeckList.propTypes = {
    decks: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        description: PropTypes.string,
        ownerHandle: PropTypes.string,
        targetLanguage: PropTypes.string,
        cardCount: PropTypes.number,
        created: PropTypes.number,
        lastUpdated: PropTypes.number
    })).isRequired,
    onAdd: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired
};

export default fadein(DeckList);


// WEBPACK FOOTER //
// ./src/components/decklist/index.js